"use client";

import { cn } from "@/lib/utils";
import { Button } from "@app/_components/ui";
import useTranslate from "@app/_hooks/useTranslate";
import useAddCartItem from "@server/hooks/cart/useAddCartItem";
import { CheckIcon } from "lucide-react";
import { useState } from "react";
import { Variant } from "types";

export default function SamplePurchaseButton({ sample }: { sample?: Variant }) {
  const t = useTranslate();
  const { addCartItem, isPendingAddCartItem: loading } = useAddCartItem();
  const [recentlyAdded, setRecentlyAdded] = useState<boolean>(false);
  const [optimisticallyAdded, setOptimisticallyAdded] =
    useState<boolean>(false);

  async function handlePurchaseSample() {
    if (!sample) return;
    setOptimisticallyAdded(true);
    try {
      await addCartItem([{ item: sample, quantity: 1 }], true);
      setRecentlyAdded(true);
      setOptimisticallyAdded(false);
      setTimeout(() => setRecentlyAdded(false), 3000);
    } catch {
      setOptimisticallyAdded(false);
    }
  }

  return (
    <Button
      disabled={!sample?.stock}
      variant="outline"
      size="lg"
      isLoading={!optimisticallyAdded && loading}
      onClick={handlePurchaseSample}
      className={cn(
        "col-span-full disabled:cursor-not-allowed",
        (recentlyAdded || optimisticallyAdded) &&
          "border-green pointer-events-none bg-green-600 text-white",
        loading && "pointer-events-none",
      )}
    >
      {recentlyAdded || optimisticallyAdded ? (
        <CheckIcon strokeWidth={1} className="size-5" />
      ) : (
        <span>
          {t("purchaseSample")}
          {!sample?.stock ? ` (${t("outOfStock")})` : null}
        </span>
      )}
    </Button>
  );
}
